import React, { useEffect, useRef, useState } from "react";

import SuccessMsg from "../../../constant/messages/SuccessMessage";
import useErrorHandle from "../../../constant/errorHandling/useErrorHandle";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import useShowAlert from "../../../utiles/AlertUtiles";
import AllStoreTable from "./AllStoreTable";
import { listMainStores, searchStore } from "../../../services/apiServices";

function AllStore() {
  const [isStoreData, setStoreData] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const showAlert = useShowAlert();
  const [suggestions, setSuggestions] = useState([]);
  const [loadingState, setLoadingState] = useState({
    fetch: false,
    search: false,
    button: false,
    add: false,
  });

  const handleError = useErrorHandle();
  const searchRef = useRef(null);

  const fetchAllStoreData = async (ispageno) => {
    checkNetworkStatus();
    setLoadingState((prev) => ({ ...prev, fetch: true }));
    const data = { pageno: ispageno || 1 };
    try {
      const storeData = await listMainStores(data);
      setStoreData(storeData);
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState((prev) => ({ ...prev, fetch: false }));
    }
  };

  const handleSelectSuggestion = async (term) => {
    checkNetworkStatus();
    setSearchTerm(term);

    if (term.trim() === "") {
      setSuggestions([]);
      return;
    }
  };
  const handleSearch = async (term) => {
    setLoadingState((prev) => ({ ...prev, button: true }));
    checkNetworkStatus();
    try {
      const data = { searchtxt: term };
      const response = await searchStore(data);
      if (response) {
        setStoreData(response);
        setItemsPerPage(50);
        setSuggestions([]);
        setSearchTerm("");
      } else {
        setStoreData([]);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState((prev) => ({ ...prev, button: false }));
    }
  };

  const handleOutsideClick = (e) => {
    if (
      searchRef.current &&
      !searchRef.current.contains(e.target) &&
      !e.target.classList.contains("suggestion-item")
    ) {
      setSearchTerm("");
      setSuggestions([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    searchRef.current?.focus();
  }, []);

  useEffect(() => {
    setStoreData([]);
    setSearchTerm("");
    setSuggestions([]);
    fetchAllStoreData();
  }, []);

  return (
    <div>
      <div className="page-breadcrumb d-flex align-items-center mb-2">
        <div className="breadcrumb-title pe-3">
          <h6>All Stores</h6>
        </div>
        <div className="ms-auto">
          <button
            type="button"
            className="btn btn-sm btn-light mt-2 mt-lg-0"
            onClick={() => window.location.reload()}
          >
            <i className="bx bx-refresh"></i> Refresh
          </button>
        </div>
      </div>
      <AllStoreTable
        itemsPerPage={itemsPerPage}
        data={isStoreData}
        loading={loadingState.fetch}
        setSuggestions={setSuggestions}
        handleSearch={handleSearch}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        suggestions={suggestions}
        isbtnLoading={loadingState.button}
        searchRef={searchRef}
        fetchAllStoreData={fetchAllStoreData}
        handleSelectSuggestion={handleSelectSuggestion}
      />
    </div>
  );
}

export default AllStore;
